import React, { useState, useEffect } from "react";
import html2canvas from 'html2canvas';
import { Line } from "react-chartjs-2";
// import { MDBContainer } from "mdbreact";
import jsPDF from 'jspdf';
import 'jspdf-autotable'
import {Helmet} from "react-helmet";
import { Col, Row } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import QRCode from "react-qr-code";
import $, { data } from 'jquery';
import { Doughnut } from "react-chartjs-2";
import {Chart, ArcElement} from 'chart.js'
Chart.register(ArcElement);

const GeneratePDF = props => {
  const { stdId } = useParams();
  const { roomIdParams } = useParams();
  const [strengths, setStrengths] = useState([]);
  const [studentProfile, setStudentProfile] = useState([]);
  const [textEvaluate, setTextEvaluate] = useState({});
  const [strengthEvaluate, setStrengthEvaluate] = useState({});
  const [domain, setDomain] = useState('');
  const [totalActivity, setTotalActivity] = useState(0);
  const [allPercent, setSetPercent] = useState([]);
  const [key, setSetKey] = useState([]);  
  const [graphData, setGraphData] = useState(null);
  const [graphShowhData, setGraphShowData] = useState(false);  
  const [maxValue, setMaxValue] = useState(0);
  const [roomId, setRoomId] = useState('');
  const [strengths2, setStrengths2] = useState([]);
  const [allPercentText, setSetPercentText] = useState([]);
  const [teacherName, setTeacherName] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [logo, setLogo] = useState('');

  const [showTeacher, setShowTeacher] = useState(false);  
  const [showSelf, setShowSelf] = useState(false);    

  const studentId = stdId ?? AuthService.getCurrentUserId()
  const rId = roomIdParams ?? AuthService.getCurrentRoomId()
  
 
  var textRoom = '';
  var textStdName = '';

  console.log(studentId)
  let color = {       
      "brave":"#FFCECE",
      "honesty" : "#FF9B9B",
      "perseverance" : "#E04E4E",
      "zest": "#B41616",
      "fairness": "#A1AEF9",
      "citizenship": "#465BCC",
      "leadership": "#1A2979",
      "humility": "#FFD2F5",
      "forgiveness": '#FFA1E9',
      "self_regulation": "#D761BB",
      "prudence": "#801967",
      "hope": "#FFDEC8",
      "spirituality": "#FFC096",
      "beauty_excellence": "#EA833D",  
      "humor": "#E46C1A",
      "gratitude": '#923806',
      "creativity": "#CDFFF6",  
      "curiosity": '#8FFFEA',    
      "judgement": "#67D2BE",
      "love_of_learning": "#2FA992",
      'perspective': '#147B68',   
      "kindness": "#D8F4FF",
      "social": "#96DAF5",
      "love": "#2893BD",
      "otherPercent": "#808080"
  };

  let newText = {
    "beauty_excellence":"การชื่นชมความงามและ<br>ความเป็นเลิศ",
    "forgiveness": "การให้อภัยและความมี<br>เมตตา",
    "gratitude": "การรู้สึกขอบคุณสิ่งรอบ<br>ตัว"
  }
  let labelsValue = [], backgroundColorValue  = [], dataValue = [],  newStrengths = [];

 



  useEffect(() => {
    
    if (studentId) {
      try {    
        var user = AuthService.getCurrentUser();
     
        var filter = {
          "domain": user.domain.name
        };
        UserService.getRoomDetail(rId).then((response) => {     
          if(rId !== 'empty'){
            filter = {
                "domain": user.domain.name,
                "roomId": rId,
                "year": response.data.data.year,
                "term": response.data.data.term,                    
            }; 
          } 
          if (response.data.data && response.data.data.teachers && response.data.data.teachers[0]) {
            setTeacherName(response.data.data.teachers[0].fullName)
          }
          if (response.data.data && response.data.data.domain) {
            setSchoolName(response.data.data.domain.displayName)
            // setLogo('/images/school/'+ response.data.data.domain.id + '_' +response.data.data.domain.name +'.png');
            setLogo(UserService.getLogoUrl());
            
          }
      }).then(() => { 

        UserService.getStrengths().then((response) => {          

            setStrengths(response.data.data)

            for (const [index, str] of response.data.data.entries()) { 
              var tempText = str.name;
              if(str.id in newText){
                tempText = newText[str.id];
              }
              newStrengths[str.id] = {
                  image: str.imageUrl,
                  name: tempText,
                  description: str.description
              }
          }
      
          console.log('newStrengths');
          console.log(newStrengths);
            return newStrengths
        }).then((strengths) => {
            setStrengths2(strengths);
            UserService.getFriendShipList(studentId, filter).then((res) => {
              const data = res.data.data[0]
              console.log(data)
              setStudentProfile(data)
              textStdName = data.user && data.user.fullName ? data.user.fullName : '';
              textRoom = data.room && data.room.displayName ? data.room.displayName : ''
              textRoom = textRoom.replace(/ม.|ป.| /g, '_');
              textStdName = textStdName.replace(/ /g, '_');

              setDomain(data.room.domain.name)
              const self = data.others.filter(function (d) { return d.user.id === studentId })[0];
              let teacher = data.others.filter(function (d) { return d.user.roles.includes("TEACHER")  && d.answerAt !== null });

              if(teacher[0]){
                teacher = teacher[0];
              } else{         
                teacher = data.others.filter(function (d) { return d.user.roles.includes("TEACHER")})[0];   
              }

              const friends = data.others.filter(function (d) { return d.user.roles.includes("STUDENT") && d.user.id !== studentId && d.answers !== null });

              let selfTextAnswer, teacherTextAnswer, selfStrengthAnswer, teacherStrengthAnswer
              if (self.answers) {
                selfTextAnswer = self.answers.filter(function (d) { return d.type === 'text' })[0];
                selfStrengthAnswer = self.answers.filter(function (d) { return d.type === 'strength' });
              }
              if (teacher.answers) {
                teacherTextAnswer = teacher.answers.filter(function (d) { return d.type === 'text' })[0];
                teacherStrengthAnswer = teacher.answers.filter(function (d) { return d.type === 'strength' });
              }
              if (selfTextAnswer && teacherTextAnswer) {
                setTextEvaluate({
                  "self" : selfTextAnswer.values[0],
                  "teacher" : teacherTextAnswer.values[0],
                  "friends" : ''
                })
              } else if (selfTextAnswer) {
                setTextEvaluate({
                  "self" : selfTextAnswer.values[0],
                  "teacher" : '',
                  "friends" : ''
                })
              } else if (teacherTextAnswer) {
                setTextEvaluate({
                  "self" : '',
                  "teacher" : teacherTextAnswer.values[0],
                  "friends" : ''
                })
              }

              //Graph

              var allAnswer0 = [];      
              var sum = 0;  
              var maxPercent = 0;
              var percent = [];
              var percentTextTemp = [];
              var key = [];
              var RID = res.data.data[0].room.id;
              let friendStrengths1 = []
              let friendStrengths2 = []
              let friendStrengths3 = []
              
              // console.log(RID);
            
              for (const [index, aAnswer] of res.data.data[0].others.entries()) { 
                      
                      if(aAnswer.answerAt != null){
                          sum += 3;

                          if(allAnswer0[aAnswer.answers[0].values[0]] === undefined){
                              allAnswer0[aAnswer.answers[0].values[0]] = 1;
                          } else {
                              allAnswer0[aAnswer.answers[0].values[0]]++
                          }
                      
                          if(allAnswer0[aAnswer.answers[1].values[0]] === undefined){
                              allAnswer0[aAnswer.answers[1].values[0]] = 1;
                          } else {
                              allAnswer0[aAnswer.answers[1].values[0]]++
                          }
  
  
                          if(allAnswer0[aAnswer.answers[2].values[0]] === undefined){
                              allAnswer0[aAnswer.answers[2].values[0]] = 1;
                          } else {
                              allAnswer0[aAnswer.answers[2].values[0]]++
                          }

                          if(studentId === aAnswer.user.id){
                              var selfText = aAnswer.answers[3].values[0];                             
                          }

                          if(studentId !== aAnswer.user.id && !aAnswer.user.roles.includes("TEACHER")){
                            console.log('aAnswer.answers')
                            if (aAnswer.answers[0]) {
                              if(friendStrengths1[aAnswer.answers[0].values[0]] === undefined){
                                friendStrengths1[aAnswer.answers[0].values[0]] = 1;
                              } else {
                                friendStrengths1[aAnswer.answers[0].values[0]]++
                              }
                            }
                            if (aAnswer.answers[1]) {
                              if(friendStrengths2[aAnswer.answers[1].values[0]] === undefined){
                                friendStrengths2[aAnswer.answers[1].values[0]] = 1;
                              } else {
                                friendStrengths2[aAnswer.answers[1].values[0]]++
                              }
                            }
                            if (aAnswer.answers[2]) {
                              if(friendStrengths3[aAnswer.answers[2].values[0]] === undefined){
                                friendStrengths3[aAnswer.answers[2].values[0]] = 1;
                              } else {
                                friendStrengths3[aAnswer.answers[2].values[0]]++
                              }
                            }
                          }
                      }
                      
                  }

                  // console.log(allAnswer0);
                  var myArr0 = Object.fromEntries(
                      Object.entries(allAnswer0).sort(([, a], [, b]) => b - a)
                  );                  
                   
                  var count = 1;
                  var otherPercent = 0;
                  var limitShow = 11;
                  var numberValue = 0;
                  $.each( myArr0, function( index, value ) {
                      numberValue = ((value*100)/sum);
                      if(count > limitShow) {
                        otherPercent += numberValue; 
                        console.log(5555555);
                      } else {                     
                        percent[index] =  numberValue.toFixed(2) + "%";
                          key.push(index);
                          labelsValue.push(newStrengths[index].name);
                          backgroundColorValue.push(color[index]);
                          dataValue.push(numberValue);
                          percentTextTemp[index] =  <div dangerouslySetInnerHTML={{ __html: newStrengths[index].name +  ' ' +percent[index]}} />;
                          if(parseFloat(maxPercent) < parseFloat(numberValue)) {
                            maxPercent = parseFloat(numberValue.toFixed(2) );
                          }
                          count++;
                        }
                      
                    });

                    if(otherPercent > 0){
                      percent['otherPercent'] =  otherPercent.toFixed(2) + "%";
                      key.push('otherPercent');
                      labelsValue.push('อื่นๆ');
                      backgroundColorValue.push(color['otherPercent']);
                      dataValue.push(otherPercent);
                      percentTextTemp['otherPercent'] =  <div dangerouslySetInnerHTML={{ __html: 'อื่นๆ ' +  percent['otherPercent']}} />;
                    }
                    console.log('percent');
                    console.log(percent);   

                    // if (selfStrengthAnswer && teacherStrengthAnswer && friendStrengths1 && friendStrengths2 && friendStrengths3) {
                      
                    //   console.log(data)
                    //   setStrengthEvaluate(data)
                    // }
                    let friendStrengths = [
                      [],
                      [],
                      []
                    ]
                    if (friendStrengths1) {
                      for (const k in friendStrengths1) {
                        friendStrengths[0].push(strengths[k].name + ' (' + friendStrengths1[k] + '/3)')
                      }
                    }
                    if (friendStrengths2) {
                      for (const k in friendStrengths2) {
                        friendStrengths[1].push(strengths[k].name + ' (' + friendStrengths2[k] + '/3)')
                      }
                    }
                    if (friendStrengths3) {
                      for (const k in friendStrengths3) {
                        friendStrengths[2].push(strengths[k].name + ' (' + friendStrengths3[k] + '/3)')
                      }
                    }
                    const dataStrengths = {
                      'friends' : [
                        friendStrengths[0],
                        friendStrengths[1],
                        friendStrengths[2]
                      ],
                      'self' : [
                        selfStrengthAnswer ? selfStrengthAnswer[0].values[0] : [],
                        selfStrengthAnswer ? selfStrengthAnswer[1].values[0] : [],
                        selfStrengthAnswer ? selfStrengthAnswer[2].values[0] : []
                      ],
                      'teacher' : [
                        teacherStrengthAnswer ? teacherStrengthAnswer[0].values[0] : [],
                        teacherStrengthAnswer ? teacherStrengthAnswer[1].values[0] : [],
                        teacherStrengthAnswer ? teacherStrengthAnswer[2].values[0] : []
                      ]
                    }

                    if(selfStrengthAnswer){
                      setShowSelf(true);
                    }

                    if(teacherStrengthAnswer){                      
                      setShowTeacher(true);
                    }

                    var dataReturn = {'percent': percent,'key':key, 'maxPercent': maxPercent, 'roomId': RID, 'strengths': dataStrengths, 'percentText': percentTextTemp};  

                    return dataReturn;
            }).then((res) => {   
              //Graph
              setSetPercent(res.percent);    
              setSetKey(res.key);
              setMaxValue(res.maxPercent)
              setRoomId(res.roomId);
              setStrengthEvaluate(res.strengths)
              setSetPercentText(res.percentText);   
            
              if(res.maxPercent > 0){
                setGraphShowData(true);
              }
              
              var graphData2 =  {
                labels: labelsValue,
                datasets: [
                  {
                    // label: 'Rainfall',
                    backgroundColor: backgroundColorValue,
                    // hoverBackgroundColor: [
                    // '#501800',
                    // '#4B5000'
                    // ],
                    data: dataValue
                  }
                ]
              };    
              setGraphData(graphData2);    


              //todo ปีการศึกษา       
              UserService.activitiesTotal(filter).then((response) => {       
                var total = 0;
                if (response && response.data && response.data.data[0]) {
                  total = response.data.data[0].total;
                }      

                  return total;
              }).then((total) => { 
                setTotalActivity(total);
                 setTimeout(() => {
                  makePDF(); 
                }, 1000)
              
              });                
          });
        });        
      }); 
      } catch (error) {

      }
    }
    
  }, []);

    const dataLine = {
              labels: ["January", "February", "March", "April", "May", "June", "July"],
              datasets: [
                {
                  label: "My First dataset",
                  fill: true,
                  lineTension: 0.3,
                  backgroundColor: "rgba(225, 204,230, .3)",
                  borderColor: "rgb(205, 130, 158)",
                  borderCapStyle: "butt",
                  borderDash: [],
                  borderDashOffset: 0.0,
                  borderJoinStyle: "miter",
                  pointBorderColor: "rgb(205, 130,1 58)",
                  pointBackgroundColor: "rgb(255, 255, 255)",
                  pointBorderWidth: 10,
                  pointHoverRadius: 5,
                  pointHoverBackgroundColor: "rgb(0, 0, 0)",
                  pointHoverBorderColor: "rgba(220, 220, 220,1)",
                  pointHoverBorderWidth: 2,
                  pointRadius: 1,
                  pointHitRadius: 10,
                  data: [65, 59, 80, 81, 56, 55, 40]
                },
                {
                  label: "My Second dataset",
                  fill: true,
                  lineTension: 0.3,
                  backgroundColor: "rgba(184, 185, 210, .3)",
                  borderColor: "rgb(35, 26, 136)",
                  borderCapStyle: "butt",
                  borderDash: [],
                  borderDashOffset: 0.0,
                  borderJoinStyle: "miter",
                  pointBorderColor: "rgb(35, 26, 136)",
                  pointBackgroundColor: "rgb(255, 255, 255)",
                  pointBorderWidth: 10,
                  pointHoverRadius: 5,
                  pointHoverBackgroundColor: "rgb(0, 0, 0)",
                  pointHoverBorderColor: "rgba(220, 220, 220, 1)",
                  pointHoverBorderWidth: 2,
                  pointRadius: 1,
                  pointHitRadius: 10,
                  data: [28, 48, 40, 19, 86, 27, 90]
                }
              ]
    }
    
    const textCutting = (text) => {
      if (text && text.length > 110) {
        return text.substring(0, 110) + '...'
      }
      return text
    }
    const makePDF =  () =>{
    

        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape

        const printArea = document.getElementById("pocketTable1");
        html2canvas(printArea, {
          scale: 3,
          allowTaint: true, useCORS: true, logging: true
        }).then(async (canvas) => {
          const dataURL = canvas.toDataURL();      
        
            const unit = "pt";
            const size = "A4"; // Use A1, A2, A3 or A4
            const orientation = "landscape"; // portrait or landscape
    
            const pdf = new jsPDF(orientation, unit, size);

          pdf.addImage(dataURL, 'JPEG', 8, 8, 830, 580);       
          await pdf.save(textStdName+'_pocketbook_room'+textRoom +'.pdf')
          setTimeout(() => {window.close(); }, 2000)
        })



    }

  const regex = /(<([^>]+)>)/ig; 
  const regex1 = /\&nbsp;/g;
  const regex2 = /  +/g;
  const regex3 = /[\u202F]/g;
  const regex4 = /\ /g;

  const truncate = (ctx, limitTemp = null) => {       
    if( ctx !== undefined){
      if(limitTemp == null){
        ctx = ctx.substring(0, 325) + '...'
      } else {
        ctx = ctx;
      }      
      
        var focusVowls = (ctx.match( /["่","้","๋","๊","็","ั","ี","ึ","ื","ิ","ุ","ู","์","ั"]/g) || []).length;
        ctx = ctx.substring(0, 325 + focusVowls)
        ctx = ctx.replace(regex, ' ');
        ctx = ctx.replace(regex1, ' ');  
        ctx = ctx.replace(regex2, ' ');  
        ctx = ctx.replace(regex3, ' ');  
        ctx = ctx.replace(regex4, ' '); 
        ctx = decodeURI(ctx);
    } else {
        ctx = '';
    }
    let limit = 70;
    let tempPlusStart = 0;
    let result = []
    var start = 0;
    if(limitTemp !== null){ 
      limit = limitTemp;
    }
    
    for(let i = 0; i <= ((ctx.length)/limit+1); i++){
        // find last char                      
        
        var length = start+limit;       

        var tempString = ctx.slice(start, length);
        var focusVowls = (tempString.match( /["่","้","๋","๊","็","ั","ี","ึ","ื","ิ","ุ","ู","์","ั"]/g) || []).length;
        length = length+(focusVowls);            

        var pre =  ctx[length-2]; 
        var last =  ctx[length-1]; 
        var next = ctx[length]; 
       
     
        // start += tempPlusStart;
  
        tempPlusStart = 0;
 

        var vowels  = ["า", "ำ", "ะ","่","้","๋","๊","็","ั", " ","ี","ึ","ื","ิ","ุ","ู","์"];
        var vowels2  = ["เ", "ไ", "ใ", "แ","ั"," "];
        
        var result1 = vowels.includes(last);
        var result2 = vowels2.includes(last);

        var result3 = vowels.includes(next);
        var result4 = vowels2.includes(pre);
        if(result3){
            if(next !== ' '){
                // console.log('44444444444');
                length -= 1;
                tempPlusStart-= 1;
                if(!(/^[ก-ฮa-zA-Z]+$/ig.test(last))){ 
                    // console.log('55555555555555');
                    length -= 1;
                    tempPlusStart-= 1;                        
                }

                if(result4){ 
                    // console.log('6666666');
                    length -= 1;
                    tempPlusStart-= 1;
                    
                }
            }            
           
        } else if( !(/^[ก-ฮa-zA-Z]+$/ig.test(last)) && !result1){
            if(result2){
                length -= 1;
                tempPlusStart-= 1;
            } else {
                if(!(/^[ก-ฮa-zA-Z]+$/ig.test(next)) && !result3) {
                    length -= 1;
                    tempPlusStart-= 1;
                } else {
                    length += 1;
                    tempPlusStart+= 1;
                }
            }


        }
      
        result.push(ctx.slice(start, length) + " ");     
        start =+ length; 
        // console.log('--------------------------------------');                         

    }
    const text = result.join('<br>')
    return text.substring(0, text.length - 5)
 }



      return (
          <div>         
          <div style={{'height': '100vh'}} class="text-center m-auto">
            <div class="loader">Loading...</div>
             <h2 style={{"color":"#3765D1"}}>Loading...</h2>    
          </div>  
          <div id="pocketTable1" className="pocketbook-pdf" style={{ "width": '820px',"height": '570px'}}>
                <div style={{ "width": '820px',"height": '370px', "display" : 'flex' }}>

                  <div style={{ "width": '270px',"height": '370px', 'textAlign' : 'center', 'position' : 'relative'}}>
                    <img src="/images/pocketbook/cover-header.png" width={'87%'} alt="" style={{"marginLeft": "14px"}} />
                    <img src="/images/pocketbook/yellow-bg.png" width={'75%'} alt="" style={{"position": "absolute","top": "148px","left": "42px","z-index": "-1"}}/>
                    {/* <img src="/images/pocketbook/white-bg.png" width={'72%'} alt="" style={{"position": "absolute","top": "158px","left": "47px","z-index": "-1"}}/> */}
                    <img src="/images/pocketbook/left.png" width={'39'} alt="" style={{"position": "absolute","top": "236px","left": "0px","z-index": "-1"}}/>
                    <div style={{"margin" : "0px 36px 0px 60px", "height" : "175px", "display": "grid"}}>                
                      <h5 className="font-sarabun-bold" align="center">{studentProfile.user && studentProfile.user.fullName ? studentProfile.user.fullName : '-'}</h5>
                      <h5 className="font-sarabun-bold" align="center">ห้อง {studentProfile.room && studentProfile.room.displayName ? studentProfile.room.displayName : '-'}  เลขที่ {studentProfile.user && studentProfile.user.no ? studentProfile.user.no : '-'}</h5>
                        <div className="d-flex mb-1">
                          <div className="d-flex" style={{"width": "50px", "padding-right" : "5px"}}>
                            <img src={logo} width={'100%'} className="m-auto" crossOrigin="true"/>
                          </div>
                          <div  className="d-flex"> 
                            <div className="m-auto">
                              <p  className="font-sarabun-bold  m-0 text-left t-12 ">{ schoolName }</p>
                              {/* <p className="font-sarabun-bold t-11 m-0 text-left" align="center">ครูประจำชั้น { teacherName }</p> */}
                            </div>
                          </div>
                        </div>
                        <p className="m-0">ศึกษาเพิ่มเติมเกี่ยวกับการสร้างอุปนิสัยเชิงบวก<br></br>ได้ที่: www.mindsetmaker.co</p>
                    </div>
                  </div>
                  <div style={{ "width": '550px',"height": '370px', 'position' : 'relative', "paddingRight": "29px" }}>
                    <img src="/images/pocketbook/top.png" width={'69'} alt="" style={{"position": "absolute","top": "0px","left": "-50px","z-index": "-1"}}/>
                    <img src="/images/pocketbook/right.png" width={'29'} alt="" style={{"position": "absolute","top": "206px","right": "0px","z-index": "-1"}}/>
                    
                    <div class={`row pocketbook pb-2 ${graphShowhData?'':'d-none'}`}> 
                        <div class="col-12 main-detail px-0" >                                           
                            <div id="capture" className="d-flex" style={{ "position": "relative", "left": "-190px" }}> 
                                <div className="w-100 m-auto" style={{ "maxWidth": "120px"}}>
                                {
                                  ( graphData) ? (
                                    <Doughnut                                      
                                        data={graphData}
                                        options={{
                                          plugins: {
                                              legend:{
                                                  display:false,
                                                  position:'bottom',
                                                  maxWidth: 180                                                                   
                                              }     
                                          }, 
                                          responsive: true, 
                                          maintainAspectRatio: true                                                         
                                      }}
                                      />     
                                      ) : (
                                          <div></div>
                                      )
                              }          
                                </div>
                                <div style={{ "position": "absolute", "zIndex": "1", "top": "51px" }} className="w-100 text-center"><p className="t-b-14">{maxValue}%</p></div>     

                                <Row style={{ "position": "absolute", "maxWidth": "410px", "right": "-170px", "height": "130px"}}>
                                {key.map((key, i) => (
                                  <Col xs={4} className="pl-3 pr-0 d-flex" key={key}>  
                                        <div className="d-inline border-radius-125" style={{"backgroundColor": color[key],"marginTop": "4px","height": "10px", "width": "10px" ,"minWidth": "10px"} }></div>                                        
                                      
                                        <div className="d-grid pl-2"><span className="t-10">{allPercentText[key]}</span></div>
                                        
                                    </Col>                                        
                                ))}                                     
                                </Row>                                                     
                            </div>           
                          </div>   
                          
                    </div>                  
                    <div>
                      <hr className={`mt-0 mb-2 mx-4 ${!showTeacher && !showSelf && !graphShowhData?'d-none':''}`}  style = {{"border-color": 'black'}}></hr>
                    </div>
                    <Row className=""> 
                      <Col className={`col-6 ${showTeacher?'':'d-none'}`}>
                        <div className="text-center">
                          <span className="header-mini" align="center"> ครูมองเห็นอุปนิสัยเชิงบวกเหล่านี้ในตัวเรา</span>
                        </div>
                        <div className="row mx-0">
                          <div className="col-4 px-0 font-weight-bold" align="center">
                            <img src={`/images/strengths/cards/${strengthEvaluate.teacher  && strengthEvaluate.teacher[0] != '' ? strengthEvaluate.teacher[0] : 'question'}.png`} className="border-gray mb-1"      width="75"/><br />
                            {/* ใช้บ่อยที่สุด */}
                          </div>
                          <div className="col-4 px-0 font-weight-bold" align="center">
                            <img src={`/images/strengths/cards/${strengthEvaluate.teacher && strengthEvaluate.teacher[1] != '' ? strengthEvaluate.teacher[1] : 'question'}.png`} className="border-gray mb-1" width="75" /><br />
                            {/* ใช้แล้วรู้สึกดีที่สุด */}
                          </div>
                          <div className="col-4 px-0 font-weight-bold" align="center">
                            <img src={`/images/strengths/cards/${strengthEvaluate.teacher && strengthEvaluate.teacher[2] != ''  ? strengthEvaluate.teacher[2] : 'question'}.png`} className="border-gray mb-1" width="75" /><br />
                            {/* ใช้แล้วบ่งบอก<br />ตัวตนที่สุด */}
                          </div>
                        </div>
                      </Col>
                      <Col className={`col-6 ${showSelf?'':'d-none'} ${showTeacher?'border-left-gray':''} `}>
                        <div className="text-center">
                          <span className="header-mini " align="center">เรามองเห็นอุปนิสัยเชิงบวกเหล่านี้ของตัวเอง</span>
                        </div>
                        <div className="row mx-0">
                          <div className="col-4 px-0 font-weight-bold" align="center">
                            <img src={`/images/strengths/cards/${strengthEvaluate.self && strengthEvaluate.self[0] != '' ? strengthEvaluate.self[0] : 'question'}.png`} className="border-gray mb-1" width="75"/><br />
                            {/* ใช้บ่อยที่สุด */}
                          </div>
                          <div className="col-4 px-0 font-weight-bold" align="center">
                            <img src={`/images/strengths/cards/${strengthEvaluate.self && strengthEvaluate.self[1] != '' ? strengthEvaluate.self[1] : 'question'}.png`} className="border-gray mb-1" width="75" /><br />
                            {/* ใช้แล้วรู้สึกดีที่สุด */}
                          </div>
                          <div className="col-4 px-0 font-weight-bold" align="center">
                            <img src={`/images/strengths/cards/${strengthEvaluate.self && strengthEvaluate.self[2] != '' ? strengthEvaluate.self[2] : 'question'}.png`} className="border-gray mb-1" width="75" /><br />
                            {/* ใช้แล้วบ่งบอก<br />ตัวตนที่สุด */}
                          </div>
                        </div>
                      </Col>
                    </Row>     
                    <Row>                   
                      <Col xs={6} className={`${showTeacher?'':'d-none'}`}>
                        <div className="">
                          <span className="t-10 font-sarabun-bold" align="center">มุมมองของครูต่ออุปนิสัยเชิงบวกของเรา</span>
                        </div>
                        <div className="mx-0 py-2">
                          <div dangerouslySetInnerHTML={{ __html: textEvaluate.teacher ? textCutting(textEvaluate.teacher) : '' }} />
                        </div>
                      </Col>
                      <Col xs={6} className={`${showSelf?'':'d-none'} ${showTeacher?'border-left-gray':''} `}>
                        <div className="">
                          <span className="t-10 font-sarabun-bold" align="center">เหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวกของตัวเอง</span>
                        </div>
                        <div className="mx-0 py-2">
                          <div dangerouslySetInnerHTML={{ __html: textEvaluate.self ? textCutting(textEvaluate.self) : '' }} />
                        </div>
                      </Col>                      
                    </Row>
                    {/* <Row className="">
                      <Col className="d-flex">
                        
                          <div  style={{ "padding":'3px', "border": '2px solid black'}}>                         
                            <QRCode value={`${process.env.REACT_APP_URL}/evaluation/friends/${studentId}`} size="60" />                        
                          </div>
                          <div className="d-flex" style={{ "background" : "#F4F8FF", "border" : 'solid 1px #B6C2D5 ', "borderRadius" : "0px 4px 4px 0px", "width" : "170px", "margin-top": "5px", "margin-bottom": "5px"}}>      
                          <div className="m-auto">
                            <span className="green2-text t-12">“มุมมองของเพื่อน”</span>
                            <br></br><span className="t-12">หรืออ่านความคิดเห็นเพิ่มเติม</span>
                          </div>      
                          </div>                  
                      </Col>
                      
                      <Col className="d-flex">                       
                        <div  style={{ "padding":'3px', "border": '2px solid black'}}>  
                          <QRCode value={`https://www.mindsetmaker.co/%E0%B9%80%E0%B8%9B%E0%B8%B4%E0%B8%94%E0%B9%83%E0%B8%88/`} size="60"  />            
                        </div>
                        <div className="d-flex" style={{ "background" : "#F4F8FF", "border" : 'solid 1px #B6C2D5' , "borderRadius" : "0px 4px 4px 0px", "width" : "170px", "margin-top": "5px", "margin-bottom": "5px"}}>    
                          <div className="m-auto">
                            <span className="t-12">ศึกษาความหมายและวิธีการ</span>
                            <br></br><span className="t-12">พัฒนาอุปนิสัยเชิงบวกของเด็กๆ</span>
                          </div>
                        </div>  
                      </Col>

                    </Row> */}

                    <Row className={`${!showTeacher && !showSelf && !graphShowhData?'':'d-none'}`}>
                        <img src="/images/pocketbook/frame2.png" width={'50%'} alt="" style={{"margin": "auto", "paddingTop": "40px","paddingBottom": "20px", "paddingLeft": "20px"}} />
                    </Row>
                    <Row className="px-0">
                      <Col className="d-flex">
                        
                          <div  style={{ "padding":'3px', "border": '2px solid black'}}>                         
                            <QRCode value={`${process.env.REACT_APP_URL}strength/detail`} size="60" />   
                            {/* <QRCode value='https://www.mindsetmaker.co/%E0%B9%80%E0%B8%9B%E0%B8%B4%E0%B8%94%E0%B9%83%E0%B8%88/' size="60" />                      */}
                            
                          </div>
                          <div className="d-flex" style={{ "background" : "#F4F8FF", "border" : 'solid 1px #B6C2D5 ', "borderRadius" : "0px 4px 4px 0px", "width" : "100%", "margin-top": "8px", "margin-bottom": "8px"}}>      
                          <div className="m-auto">   <span className="t-14">สามารถศึกษาเพิ่มเติม 24 character strengths ผ่าน QR CODE</span>
                          </div>      
                          </div>                  
                      </Col>         
                    </Row>
                    <div></div>
                  </div>
                </div>

                <div  style={{ "width": '820px',"height": '200px' }}>
                  <img src="/images/pocketbook/pocketbook-new-design-footer.png" width={'100%'} height={'100%'} alt=""/>
                </div>
          </div>
          </div>   
      );
};

export default GeneratePDF;